import PropTypes from 'prop-types';

export const Show = ({ when, children }) => {
    return when ? <>{children}</> : null;
};

Show.propTypes = {
    children: PropTypes.node,
    when: PropTypes.any,
};
